import name from '../router/name'
const userConfig = [
    {
        menu: '客户中心',
        key: 'userManager',
        icon: 'user',
        childen: [
            {
                subMenu: '用户管理',
                routerName: name.user,
                subKey: name.user
            },
//            {
//                subMenu: '发票中心',
//                routerName: name.receipt,
//                subKey: name.receipt
//            },
            {
                subMenu: '意见反馈',
                routerName: name.suggest,
                subKey: name.suggest
            }
        ]
    }
]
export default userConfig;